let overlayCount: number = 0;

export const overlayGuard = {
  enter() {
    overlayCount += 1;
  },

  exit() {
    overlayCount = Math.max(0, overlayCount - 1);
  },

  isActive() {
    return overlayCount > 0;
  },
};
